"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamoModelType = void 0;
var DynamoModelType;
(function (DynamoModelType) {
    DynamoModelType["TASK"] = "TASK";
    DynamoModelType["ORG"] = "ORG";
    DynamoModelType["ROLE"] = "ROLE";
    DynamoModelType["CATEGORY"] = "CATEGORY";
    DynamoModelType["OPPORTUNITY_LOT"] = "OPPORTUNITY_LOT";
    DynamoModelType["HISTORICAL_AWARD"] = "HISTORICAL_AWARD";
    DynamoModelType["CART"] = "CART";
    DynamoModelType["PROJECT"] = "PROJECT";
    DynamoModelType["ACTIVITY"] = "ACTIVITY";
    DynamoModelType["CATEGORY_LEVEL"] = "CATEGORY_LEVEL";
    DynamoModelType["PRODUCT"] = "PRODUCT";
    DynamoModelType["QUOTE"] = "QUOTE";
    DynamoModelType["QUOTE_LINE_ITEM"] = "QUOTE_LINE_ITEM";
    DynamoModelType["PRICE_BOOK"] = "PRICE_BOOK";
    DynamoModelType["PRICE_APPROVAL"] = "PRICE_APPROVAL";
    DynamoModelType["CUSTOMER"] = "CUSTOMER";
    DynamoModelType["PRICE_BOOK_CATEGORY"] = "PRICE_BOOK_CATEGORY";
    DynamoModelType["AVERAGE_SELLING_PRICE"] = "AVERAGE_SELLING_PRICE";
    DynamoModelType["JOB_ROLE"] = "JOB_ROLE";
    DynamoModelType["MEAT_CONFIGURATION"] = "MEAT_CONFIGURATION";
    DynamoModelType["MEAT_LOT_SIMULATION"] = "MEAT_LOT_SIMULATION";
    DynamoModelType["DATA_CONFIG"] = "DATA_CONFIG";
    DynamoModelType["DATA_CONFIG_NAME"] = "DATA_CONFIG_NAME";
    DynamoModelType["DATA_UPLOAD"] = "DATA_UPLOAD";
    DynamoModelType["DATA_UPLOAD_TYPE"] = "DATA_UPLOAD_TYPE";
    DynamoModelType["STATUS"] = "STATUS";
    DynamoModelType["OPPORTUNITY_SELECTION"] = "OPPORTUNITY_SELECTION";
    DynamoModelType["OPPORTUNITY_SELECTION_ID"] = "OPPORTUNITY_SELECTION_ID";
    DynamoModelType["VAM_ID"] = "VAM_ID";
    DynamoModelType["NOTICE_VAM_ID"] = "NOTICE_VAM_ID";
    DynamoModelType["TAGS"] = "TAGS";
    DynamoModelType["ORGANISATION_PROFILE_UPLOAD"] = "ORGANISATION_PROFILE_UPLOAD";
    DynamoModelType["PROPOSAL"] = "PROPOSAL";
    DynamoModelType["OPPORTUNITY"] = "OPPORTUNITY";
    DynamoModelType["TEAM"] = "TEAM";
    DynamoModelType["PRODUCT_CODE"] = "PRODUCT_CODE";
    DynamoModelType["COMPETITOR"] = "COMPETITOR";
    DynamoModelType["PRODUCT_CATALOG_CODE"] = "PRODUCT_CATALOG_CODE";
    DynamoModelType["DASHBOARD_TEAM_STATS"] = "DASHBOARD_TEAM_STATS";
    DynamoModelType["OPPORTUNITY_ID"] = "OPPORTUNITY_ID";
    DynamoModelType["COUNTRY"] = "COUNTRY";
    DynamoModelType["OPPORTUNITY_LOT_ID"] = "OPPORTUNITY_LOT_ID";
    DynamoModelType["MEAT_CONFIGURATION_ID"] = "MEAT_CONFIGURATION_ID";
    DynamoModelType["LOT_SIMULATION_ID"] = "LOT_SIMULATION_ID";
    DynamoModelType["ERP_TYPE"] = "ERP_TYPE";
    DynamoModelType["REQUEST_TYPE"] = "REQUEST_TYPE";
    DynamoModelType["INTEGRATION_SYNC"] = "INTEGRATION_SYNC";
    DynamoModelType["ENTITY_ID"] = "ENTITY_ID";
    DynamoModelType["COMPETITOR_HISTORICAL_CRITERIA"] = "COMPETITOR_HISTORICAL_CRITERIA";
    DynamoModelType["COMPETITOR_HISTORICAL_PRICE"] = "COMPETITOR_HISTORICAL_PRICE";
    DynamoModelType["COMPETITOR_HISTORICAL_AWARD"] = "COMPETITOR_HISTORICAL_AWARD";
    DynamoModelType["CRITERIA"] = "CRITERIA";
    DynamoModelType["COMPETITOR_PRODUCT"] = "COMPETITOR_PRODUCT";
    DynamoModelType["RECORD_TYPE"] = "RECORD_TYPE";
    DynamoModelType["REQUEST_FOR_QUOTE"] = "REQUEST_FOR_QUOTE";
    DynamoModelType["PRICE_BOOK_ENTRY"] = "PRICE_BOOK_ENTRY";
    DynamoModelType["MESSAGE"] = "MESSAGE";
    DynamoModelType["PROJECT_ID"] = "PROJECT_ID";
    DynamoModelType["THREAD_ID"] = "THREAD_ID";
    DynamoModelType["MESSAGE_ID"] = "MESSAGE_ID";
    DynamoModelType["USER"] = "USER";
    DynamoModelType["TEAM_ID"] = "TEAM_ID";
    DynamoModelType["DOCUMENT_CENTRE"] = "DOCUMENT_CENTRE";
    DynamoModelType["FILE_PATH"] = "FILE_PATH";
    DynamoModelType["USER_CART"] = "USER_CART";
    DynamoModelType["LOT_CONFIGURATION"] = "LOT_CONFIGURATION";
    DynamoModelType["CART_PRODUCT_ID"] = "CART_PRODUCT_ID";
    DynamoModelType["CUSTOMER_MAPPING"] = "CUSTOMER_MAPPING";
    DynamoModelType["CUSTOMER_TYPE"] = "CUSTOMER_TYPE";
    DynamoModelType["OPPORTUNITY_STATUS"] = "OPPORTUNITY_STATUS";
    DynamoModelType["QUOTE_STATUS"] = "QUOTE_STATUS";
    DynamoModelType["OBJECT_STATUS"] = "OBJECT_STATUS";
    DynamoModelType["OBJECT_TYPE"] = "OBJECT_TYPE";
    DynamoModelType["ORIGINAL_ID"] = "ORIGINAL_ID";
    DynamoModelType["COUNTRY_CODE"] = "COUNTRY_CODE";
    DynamoModelType["SUPPLIER_ID"] = "SUPPLIER_ID";
    DynamoModelType["PRODUCT_ID"] = "PRODUCT_ID";
    DynamoModelType["AWARD_TYPE"] = "AWARD_TYPE";
    DynamoModelType["CUSTOMER_ID"] = "CUSTOMER_ID";
})(DynamoModelType = exports.DynamoModelType || (exports.DynamoModelType = {}));
//# sourceMappingURL=data:application/json;base64,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